import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import ApiService from "../../../ApiService";
import DispatchProps from "../../../../utils/DispatchProps";
import PageTitle from "../../../PageTitle";
import {IRootState} from "../../../../store";
import {CommandBarButton, MessageBarType, TextField} from "office-ui-fabric-react";
import Actions from "../../../../redux/Actions";

interface ContainerImageEditPageProps
{
    imageName: string;
    apiService: ApiService;
}

interface ContainerImageEditPageState
{
    defaultTag?: string;
    saving: boolean;
}

class ContainerImageEditPage extends Component<ContainerImageEditPageProps & DispatchProps, ContainerImageEditPageState> {

    constructor(props: ContainerImageEditPageProps & DispatchProps) {
        super(props);

        this.state = {
            defaultTag: undefined,
            saving: false
        }
    }

    async componentDidMount() {

        const defaultTag = await this.props.apiService.getContainerImageTagDefault(this.props.imageName);

        this.setState({
            defaultTag
        });
    }

    async componentDidUpdate(prevProps: Readonly<ContainerImageEditPageProps & DispatchProps>, prevState: Readonly<ContainerImageEditPageState>, snapshot?: any): Promise<void>
    {

    }
    
    private save = async (): Promise<void> => {
        
        if(this.state.defaultTag === undefined)
        {
            return;
        }
        
        this.setState({
            saving: true
        });
        
        try
        {
            await this.props.apiService.putContainerImageTagDefault(this.props.imageName,this.state.defaultTag!);

            this.props.dispatch(Actions.showMessageBar(`Successfully saved default tag`,MessageBarType.success));
        }
        catch (e)
        {
            this.props.dispatch(Actions.showMessageBar(`Failed to save ${e}`,MessageBarType.error));
        }
        finally
        {
            this.setState({
                saving: false
            })
        }
    }

    public render(): JSX.Element {
        
        const title = `Edit default tag for ${this.props.imageName}`;
        
        return (
            <Fragment>
                <PageTitle title={title}/>
                
                <div className={"card flex-item--flex-1"}>

                    <div className={"card__header"}>
                        <div className="card__title">
                            {title}
                        </div>
                        <CommandBarButton
                            iconProps={{ iconName: "save" }}
                            text="Save"
                            disabled={this.state.saving}
                            onClick={this.save}
                        />
                    </div>
                    <div className={"card__content"}>
                        <TextField
                            label="Default Tag"
                            value={this.state.defaultTag}
                            required
                            disabled={this.state.saving}
                            onChange={(event,newValue) => {
                                this.setState({
                                    defaultTag: newValue
                                });
                            }
                        }/>
                        
                    </div>

                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): ContainerImageEditPageProps => {

        return {
            imageName: ownProps.match.params[0],
            apiService: state.auth.apiService
        };
    }
)(ContainerImageEditPage)